// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xc4J","right":"Footer_right__35JJj","buttons":"Footer_buttons__2Yyw_"};